<template>
  <div class="main-page">
    <Menus title="留言咨询" />
    <div class="container-flex">
      <div class="content">
        <div class="title">
          申请须知
        </div>
        <div class="desc">
          <p>1、本栏目是本站为群众提供法律问题咨询服务板块，解答内容仅供您参考之用，不具备任何法律效力。</p>
          <p>2、本栏目除姓名、手机号外的内容全部公开，请不要填写您个人或他人的隐私信息。</p>
          <p>3、请您把要咨询的问题尽量描述清楚，以便进行有针对性的回答。</p>
          <p>4、不要包含侮辱、诽谤及违法用语。</p>
          <div class="tipinfo">
            提示：请务必阅读须知。
          </div>
        </div>
        <router-link to="/advisory/message/info?url=/advisory/message/add"
                     class="button">
          知道了
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import Menus from '@/components/Menu'
import { MEDIATION_APPLY } from '../../datas/constants/statistics.js'
export default {
  components: {
    Menus
  },
  mounted () {
    this.$root.getStatistics(MEDIATION_APPLY)
  }
}
</script>
<style lang="stylus" scoped>
.content
  width 12.7rem
  display block
  margin 0 auto 0.3rem auto
  padding 0.5rem 0.7rem 0.6rem 0.7rem
  background-color rgba(255, 255, 255, 0.2)
  border-radius 0.3rem
  border solid 1px rgba(255, 255, 255, 0.2)
  color #fff
  .title
    font-size 0.3rem
    line-height 0.3rem
    padding-bottom 0.56rem
    letter-spacing 1px
  .info-title
    font-size 0.28rem
    padding 0.15rem 0
  .desc
    font-size 0.24rem
    line-height 2
  .tipinfo
    letter-spacing 0
    color #ec3839
  .button
    display block
    margin 0.6rem auto 0 auto
    width 2.78rem
    text-align center
    height 0.9rem
    line-height 0.9rem
    border 0
    color #fff
    background-color #fc9d0b
    border-radius 0.1rem
    font-size 0.28rem
</style>
